<template>
  <v-row
    class="symbology-row"
    dense
    align="center"
    no-gutters
  >
    <v-col
      v-if="lines?.length"
      cols="11"
      class="pr-2"
    >
      <v-select
        dark
        :value="lineSelected"
        :items="lines"
        hide-details
        dense
        outlined
        return-object
        :menu-props="{ top: true, offsetY: true, auto: false }"
        style="background-color: #FFFFFF55;"
        @input="$emit('update:lineSelected', $event)"
      >
        <template
          #selection="{ item }"
        >
          <img
            :src="assetSrc(item)"
            height="34"
            width="110"
          >
        </template>
        <template
          #item="{ item }"
        >
          <img
            :src="assetSrc(item)"
            height="34"
            width="110"
          >
        </template>
      </v-select>
    </v-col>

    <v-col
      cols="1"
      class="d-flex justify-center"
    >
      <v-tooltip
        bottom
      >
        <template
          #activator="{ on, attrs }"
        >
          <v-btn
            fab
            small
            color="primaryLight"
            v-bind="attrs"
            elevation="0"
            :class="{ activeBTN: activeKey === 'polylineButton' }"
            v-on="on"
            @click="$emit('draw', 'polyline')"
          >
            <v-icon
              small
              color="white"
            >
              mdi-vector-polyline
            </v-icon>
          </v-btn>
        </template>
        <span>Trazar línea</span>
      </v-tooltip>
    </v-col>

    <v-col
      v-if="polygons?.length"
      cols="11"
      class="pr-2 mt-3"
    >
      <v-select
        dark
        :value="polygonSelected"
        :items="polygons"
        hide-details
        dense
        outlined
        return-object
        :menu-props="{ top: true, offsetY: true, auto: false }"
        style="background-color: #FFFFFF55;"
        @input="$emit('update:polygonSelected', $event)"
      >
        <template
          #selection="{ item }"
        >
          <img
            :src="assetSrc(item)"
            height="34"
            width="110"
          >
        </template>
        <template
          #item="{ item }"
        >
          <img
            :src="assetSrc(item)"
            height="34"
            width="110"
          >
        </template>
      </v-select>
    </v-col>

    <v-col
      cols="1"
      class="d-flex justify-center"
    >
      <v-tooltip
        bottom
      >
        <template
          #activator="{ on, attrs }"
        >
          <v-btn
            fab
            small
            color="primaryLight"
            v-bind="attrs"
            :class="{ activeBTN: activeKey === 'polygonButton' }"
            v-on="on"
            elevation="0"
            @click="$emit('draw', 'polygon')"
          >
            <v-icon
              small
              color="white"
            >
              mdi-vector-polygon
            </v-icon>
          </v-btn>
        </template>
        <span>Trazar polígono</span>
      </v-tooltip>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'SymbologyLinePolygonRow',
  props: {
    lines: { type: Array, default: () => [] },
    polygons: { type: Array, default: () => [] },
    lineSelected: { type: [Object, null], default: null },
    polygonSelected: { type: [Object, null], default: null },
    activeKey: { type: [String, null], default: null },
    basePath: { type: String, default: 'simbologia_v3' }
  },
  methods: {
    assetSrc(item) {
      return require(`@/assets/${this.basePath}/${item.src}`)
    }
  }
}
</script>

<style scoped>
.symbology-row {
  padding: 0 12px 6px 0;
}

.activeBTN {
  border: 2px solid rgb(255, 255, 255);
  border-radius: 999px;
}
</style>
